<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-blueGray-200"
  >
    <div class="rounded-t mb-0 px-4 py-3 border-0 bg-emerald-500">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full px-4 max-w-full flex-grow flex-1">
          <h3 class="font-semibold text-lg text-black">INVOICE LISTS</h3>
        </div>
      </div>
    </div>
    <!-- Filter / Sort Bar -->
    <div class="flex flex-wrap items-center gap-2 px-4 py-2 bg-blueGray-100 border-b">
      <label class="text-xs font-bold uppercase text-blueGray-500">From:</label>
      <input type="date" v-model="filterDateFrom" class="border rounded px-2 py-1 text-sm" />
      <label class="text-xs font-bold uppercase text-blueGray-500">To:</label>
      <input type="date" v-model="filterDateTo" class="border rounded px-2 py-1 text-sm" />
      <label class="text-xs font-bold uppercase text-blueGray-500 ml-2">Sort:</label>
      <select v-model="sortOrder" class="border rounded px-2 py-1 text-sm">
        <option value="latest">Latest First</option>
        <option value="oldest">Oldest First</option>
      </select>
    </div>

    <div class="block w-full overflow-x-auto">
      <table class="items-center w-full bg-transparent border-collapse">
        <thead>
          <tr>
            <th class="text-white px-6 align-middle border border-solid py-3 text-lg uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-600">
              Invoice Date
            </th>
            <th class="text-white px-6 align-middle border border-solid py-3 text-lg uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-600">
              Invoice
            </th>
            <th class="text-white px-6 align-middle border border-solid py-3 text-lg uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-blueGray-600">
              Description
            </th>
            <th class="text-white px-6 align-middle border border-solid py-3 text-lg uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center bg-blueGray-600">
              Amount
            </th>
            <th class="text-white px-6 align-middle border border-solid py-3 text-lg uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-center bg-blueGray-600">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="invoice in filteredInvoices"
            :key="invoice.id"
            class="border-b border-gray-300"
          >
            <td class="px-6 align-middle py-3 text-lg whitespace-nowrap font-semibold text-left">
              {{ formatToYmd(invoice.date_purchased) }}
            </td>
            <td class="px-6 align-middle py-3 text-sm whitespace-nowrap font-semibold text-left">
              <button
                @click="openInvoiceFilePreview(invoice.id, 'invoice')"
                class="bg-emerald-500 text-white text-xs font-bold px-3 py-1 rounded shadow hover:shadow-md"
                title="View Invoice"
              >
                <i class="fas fa-eye mr-1"></i> View
              </button>
            </td>
            <td class="px-6 align-middle py-3 text-sm whitespace-nowrap font-semibold text-left">
              {{ invoice.description }}
            </td>
            <td class="px-6 align-middle py-3 text-lg whitespace-nowrap font-semibold text-left">
              {{ formattedPrice(invoice.invoice_price) }}
            </td>
            <td class="px-6 align-middle py-3 text-lg whitespace-nowrap font-semibold text-left">
              <div v-if="invoice.is_client_approved == 0">
                <button
                  @click="approveInvoice(invoice.id)"
                  class="bg-lightBlue-400 text-black active:bg-blueGray-600 text-sm font-bold uppercase px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                >
                  Approved
                </button>
                <button
                  @click="declineInvoice(invoice.id)"
                  class="bg-red-600 text-black active:bg-blueGray-600 text-sm font-bold uppercase px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                >
                  Decline
                </button>
              </div>
              <div v-else>
                <span v-if="invoice.is_client_approved == 1" class="text-green-600">Approved</span>
                <span v-else class="text-red-600">Declined</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/dist/sweetalert2.min.css";
export default {
  data() {
    return {
      isModalOpen: false,
      invoices: [],
      sortOrder: "latest",
      filterDateFrom: "",
      filterDateTo: "",
    };
  },
  computed: {
    filteredInvoices() {
      let list = [...this.invoices];
      if (this.filterDateFrom) {
        list = list.filter((i) => i.date_purchased >= this.filterDateFrom);
      }
      if (this.filterDateTo) {
        list = list.filter((i) => i.date_purchased <= this.filterDateTo + "T23:59:59");
      }
      list.sort((a, b) => {
        const da = new Date(a.date_purchased);
        const db = new Date(b.date_purchased);
        return this.sortOrder === "latest" ? db - da : da - db;
      });
      return list;
    },
  },
  methods: {
    getFileNameFromUrl(url) {
      // Extracts the file name from a URL
      const parts = url.split("/");
      return parts[parts.length - 1];
    },
    formattedPrice(value) {
      if (!value) return "$0.00";
      let num = parseFloat(value);
      if (isNaN(num)) return "$0.00";

      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
    },
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.fetchPayables();
      this.isModalOpen = false;
    },
    async fetchPayables() {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/client_fetch_vendors_invoice`,
          [],
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.invoices = response.data.data;
      } catch (error) {
        // Handle errors
        console.error("Backend error:", error);
      }
    },
    formatToYmd(dateTimeString) {
      const date = new Date(dateTimeString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    async openInvoiceFilePreview(invoiceId, fileType, receiptIndex = 0) {
      try {
        const token = localStorage.getItem("token");
        const { data } = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/invoice-file-signed-url`,
          {
            invoice_id: invoiceId,
            file_type: fileType === "receipt" ? "receipt" : "invoice",
            receipt_index: receiptIndex,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        this.openFileSwal(
          data.signed_url,
          data.filename,
          data.allow_google_docs_viewer,
          data.download_url || data.signed_url,
          data.office_embed_source_url || null
        );
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Could not open file",
          text:
            (error.response && error.response.data && error.response.data.message) ||
            "Please try again.",
        });
      }
    },
    openFileSwal(
      previewUrl,
      filename,
      allowGoogleDocsViewer = false,
      downloadUrl = null,
      officeEmbedSourceUrl = null
    ) {
      const dl = downloadUrl || previewUrl;
      Swal.fire({
        title: filename,
        html: this.getHtmlContent(
          previewUrl,
          filename,
          allowGoogleDocsViewer,
          dl,
          officeEmbedSourceUrl
        ),
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false,
        didOpen: (popup) => {
          const btn = popup.querySelector(".btn_invoice_modal_download");
          if (!btn) return;
          btn.addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (dl) {
                window.open(dl, "_blank", "noopener,noreferrer");
              }
            },
            { once: true }
          );
        },
      });
    },
    // eslint-disable-next-line no-unused-vars
    getHtmlContent(previewUrl, file_name, allowGoogleDocsViewer = false, downloadUrl = null, officeEmbedSourceUrl = null) {
      const srcEsc = (u) => String(u).replace(/&/g, "&amp;").replace(/"/g, "&quot;");
      let content = "";
      /* Use a unique class so Payables.vue global .btn_download handler does not double-fire */
      var btn_class =
        "bg-lightBlue-600 text-white text-sm font-bold uppercase px-6 py-3 rounded shadow outline-none focus:outline-none mr-1 mb-1 w-half ease-linear transition-all duration-150 btn_invoice_modal_download";
      if (this.isImage(file_name)) {
        content += `<img src="${srcEsc(previewUrl)}" style="max-width: 100%; max-height: 100%;">`;
        content += `<br><button type="button" class="${btn_class}">Download</button>`;
      } else if (this.isPdf(file_name)) {
        content += `<iframe src="${srcEsc(previewUrl)}" style="width:100%; height:70vh; border:0;" title="PDF Preview"></iframe>`;
        content += `<br><button type="button" class="${btn_class}">Download</button>`;
      } else if (this.isWord(file_name)) {
        if (allowGoogleDocsViewer) {
          /* Office Online fetches this URL server-side; use Laravel proxy (short) not S3 presigned (long). */
          const docSrc = officeEmbedSourceUrl || previewUrl;
          const embedUrl = this.getOfficeWebViewerUrl(docSrc);
          content += `<iframe src="${srcEsc(embedUrl)}" style="width:100%; height:70vh; border:0;" title="Document Preview" allowfullscreen></iframe>`;
        } else {
          content += `<p class="text-sm text-left">Word documents cannot be previewed in the browser. Please download the file.</p>`;
        }
        content += `<br><button type="button" class="${btn_class}">Download</button>`;
      } else if (this.isExcel(file_name)) {
        content += `<p class="text-sm text-left">Please download the file to view.</p>`;
        content += `<br><button type="button" class="${btn_class}">Download</button>`;
      } else {
        content += "Unsupported file type";
      }

      return content;
    },
    isImage(fileName) {
      const imageExtensions = [".png", ".jpg", ".jpeg", ".gif", ".bmp"];
      return imageExtensions.some((ext) =>
        fileName.toLowerCase().endsWith(ext)
      );
    },
    isPdf(fileName) {
      return fileName.toLowerCase().endsWith(".pdf");
    },
    isWord(fileName) {
      const value = fileName.toLowerCase();
      return value.endsWith(".doc") || value.endsWith(".docx");
    },
    isExcel(fileName) {
      // Check if the MIME type indicates an Excel file
      return fileName.toLowerCase().endsWith(".xlsx");
    },
    /** Office Online embed (works in iframes; Google Docs viewer often refuses to connect). */
    getOfficeWebViewerUrl(fileUrl) {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        fileUrl
      )}`;
    },
    async approveInvoice(invoiceId) {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to approve this invoice?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, approve it!",
        cancelButtonText: "Cancel",
      });

      if (confirmation.isConfirmed) {
        try {
          const token = localStorage.getItem("token");
          const response = await axios.post(
            `${process.env.VUE_APP_BACKEND_DOMAIN}/api/clientApproveInvoice`,
            { invoice_id: invoiceId },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Invoice Approved",
              text: "The invoice has been successfully approved.",
            });
            this.fetchPayables(); // Refresh the invoice list
          } else {
            Swal.fire({
              icon: "error",
              title: "Approval Failed",
              text:
                response.data.message ||
                "An error occurred while approving the invoice.",
            });
          }
        } catch (error) {
          console.error("Error approving invoice:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to approve the invoice. Please try again later.",
          });
        }
      }
    },

    async declineInvoice(invoiceId) {
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to decline this invoice?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, decline it!",
        cancelButtonText: "Cancel",
      });

      if (confirmation.isConfirmed) {
        try {
          const token = localStorage.getItem("token");
          const response = await axios.post(
            `${process.env.VUE_APP_BACKEND_DOMAIN}/api/clientDeclineInvoice`,
            { invoice_id: invoiceId },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Invoice Declined",
              text: "The invoice has been successfully declined.",
            });
            this.fetchPayables(); // Refresh the invoice list
          } else {
            Swal.fire({
              icon: "error",
              title: "Decline Failed",
              text:
                response.data.message ||
                "An error occurred while declining the invoice.",
            });
          }
        } catch (error) {
          console.error("Error declining invoice:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to decline the invoice. Please try again later.",
          });
        }
      }
    },
  },
  mounted() {
    this.fetchPayables();
  },
};
</script>
